@if (changeSetOptions.length > 1 && selectedChangeSet) {
  <div class="change-set-container flex-container">
    <div class="select-trigger-wrapper flex">
      <div (click)="toggleDisplayChangeSetDropdown()" class="flex">
        <span [attr.title]="selectedChangeSet.text">{{selectedChangeSet.text}}</span><i class="sap-icon">&#xe1e2;</i>
      </div>
      <i class="sap-icon info-icon" (click)='onInfoClick(MenuInfoLinks.ChangeSet)' [title]="'ChangeSet.HelpIcon.Title' | translate" [attr.aria-label]="'ChangeSet.HelpIcon.Title' | translate">&#xe1c3;</i>
    </div>
    <div class="change-set-select-container">
      @if (displayChangeSetDropdown) {
        <cpq-select #select [id]="'changeSetInput'" [type]="SelectType.Searchable" [label]="{key: '', placeholder: 'ChangeSet.SearchInput.Placeholder'}"
          [focusOnLoad]="true" (focusout)='selectPreviousChangeSetIfEmpty()' (selectedItemText)="toggleDisplayChangeSetDropdown()" [items]="changeSetOptions" (onChange)="selectChangeSet()"
        [dropdownListClass]="'change-set-suggestions-container'" [(ngModel)]="selectedChangeSet.id" [createNewItemOptions]="createNewItemOptions"></cpq-select>
      }
    </div>
  </div>
}
<div class="logo">
  <menu-search [nodes]="menies"></menu-search>
</div>
<div class="cald_sidebar" [ngClass]="{ 'cald_sidebar-with-change-set': changeSetOptions.length > 1 }">
  @if (isHiddenInit && isTranslated) {
    <menu-node [nodes]="menies">
    </menu-node>
  }
</div>
